export const getDocumentUploadingSelector = (state) =>
  state.documentStorageReducer.uploading;
export const getUploadedDocumentLocation = (state) =>
  state.documentStorageReducer.documentLink;
